import React from 'react';
import Footer from '../Footer/Footer';
import logo from '../../assets/Nandus.png';
import './Offline.scss';

const Offline = () => {
  return (
    <>
      <header className="header">
        <nav className="headerNavbar">
          <div className="site-logo-big">
            <img src={logo} alt="" />
          </div>
        </nav>
      </header>
      <div className="offline-wrapper">
        {/* <Header /> */}

        <div className="offlineContainer">
          <div className="errorMsg">
            You are offline please connect to the internet.
          </div>
          <div className="errorBtnContainer">
            <button
              className="errorBtn"
              onClick={() => window.location.reload(true)}
            >
              Refresh
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Offline;
